<div class="good-item">
  <img
    class="good-item__img"
    [src]="'assets/images/goods-block/' + good.src | bmAssetUrl"
    alt="{{ good.title }} cover"
  />
  <h3 class="good-item__heading">{{ good.title }}</h3>
  <div class="good-item__details">
    <div class="good-item__btn-container">
      <bmcore-button title="{{ lg.button.moreDetails }}" routerPath="/goods/{{ good.id }}" icon="btv-icon-btn-details">
      </bmcore-button>
    </div>
    <p class="good-item__price">{{ good.price }} {{ currencySign }}</p>
  </div>
</div>
